import React from "react";
import Logo from "@/components/Logo";
import usePageTitle from "@/lib/usePageTitle";

/**
 * Maintenance / Coming-Soon splash. Shown on `/` when the preview key is not present.
 * Bypass with `?preview=<REACT_APP_PREVIEW_KEY>` — the key is then stored in localStorage.
 */
export default function Maintenance() {
  usePageTitle("Bald verfügbar");
  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--tonneva-bg)] px-6 relative overflow-hidden" data-testid="maintenance-page">
      <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full opacity-25 blur-3xl" style={{ background: "linear-gradient(135deg, #3FA64E 0%, #2A86A8 100%)" }} />
      <div className="absolute -bottom-32 -left-40 w-[500px] h-[500px] rounded-full opacity-20 blur-3xl" style={{ background: "linear-gradient(135deg, #2A86A8 0%, #3FA64E 100%)" }} />

      <div className="relative max-w-lg w-full text-center">
        <div className="flex justify-center mb-8">
          <Logo size={72} withText={true} textClass="text-3xl" />
        </div>

        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/70 border border-black/10 backdrop-blur mb-6 text-xs uppercase tracking-[0.24em] font-bold text-[var(--tonneva-primary)]">
          <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" /> In Vorbereitung
        </div>

        <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tight text-[var(--tonneva-fg)] mb-4">
          Bald verfügbar.
        </h1>

        <p className="text-lg text-[var(--tonneva-muted)] leading-relaxed mb-8">
          Wir bauen gerade die smarteste Plattform für Mülltonnenreinigung in Deutschland.
          Bleib in Kontakt — wir melden uns bald.
        </p>

        <a
          href="mailto:info@tonneva.de"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-white font-semibold text-sm hover:opacity-90 transition"
          style={{ background: "linear-gradient(135deg, #3FA64E 0%, #2A86A8 100%)" }}
          data-testid="maintenance-contact-mail"
        >
          info@tonneva.de
        </a>

        <div className="mt-16 text-xs text-[var(--tonneva-muted)]/70">
          © Tonneva GmbH · Multi-Tenant SaaS für Mülltonnenreinigung
        </div>
      </div>
    </div>
  );
}
